module.exports = __webpack_public_path__ + "static/cist-c550c861767ada373be3dc333bb41db4.svg";